module.exports = __webpack_public_path__ + "img/boy_default_avatar.075f3d02.png";